import {Component} from "@angular/core";


@Component({
  selector: 'aw-sales-container',
  templateUrl: './sales-container.component.html',
  styleUrls: ['./sales-container.component.scss']
})
export class SalesContainerComponent {}
